import { useTranslation } from "react-i18next";

import type { StageBranding } from "@msc/shared";

import { StageLogos } from "./StageLogos.js";

/**
 * Neutrale Zwischenfolie — und zugleich der Anfangszustand der Bühne.
 *
 * Sie erfüllt die Vorgabe „nie ein Fehler, nie ein Spinner": Solange kein
 * Snapshot da ist (Fenster gerade geöffnet, Cockpit antwortet noch nicht,
 * Kanal kurz still), zeigt das Kundenfenster das mindsquare-Logo und einen
 * freundlichen Satz statt eines technischen Zustands. Derselbe Anblick
 * entsteht, wenn der Lead im Termin bewusst auf Pause schaltet — dann mit dem
 * Logo des Kunden daneben, sofern eines hinterlegt ist (D10).
 */
export function PauseSlide({ branding }: { branding?: StageBranding | null }) {
  const { t } = useTranslation();
  return (
    <div className="stage-slide stage-slide-pause">
      <StageLogos customerLogoUrl={branding?.logoUrl} size="large" />
      <p className="stage-sub">{t("stage.pause")}</p>
    </div>
  );
}
